import React, { Component } from 'react';
import Firebase from 'firebase';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddStore from './addStore'
import AddFromFile from './addFromFile'
import { DataTable } from 'react-data-components';


var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);


const prueba = ({ match }) => {
    console.log("prueba", match)
}


export default class stores extends React.Component {
    constructor() {
        super();
        this.state = {
            stores: {},
            showModal: false
        }
        this.callBack = this.callBack.bind(this);
        this.renderDataTable = this.renderDataTable.bind(this);
    }

    componentDidMount() {
        prueba;
        var userRef = Firebase.database().ref('admin_users').child(localStorage.uid)
            .once('value')
            .then(resp => {
                this.setState({ user: resp.val() });
                var storeRef = Firebase.database().ref('stores')
                    .child(localStorage.client_id).once('value')
                    .then(resp => {
                        if (resp.val()) {
                            this.setState({
                                stores: resp.val(),
                                titulos: Object.keys(resp.val()[0])
                            });
                        }
                    });
            });
    }

    updateStores() {
        this.setState({ stores: {} });
        var userRef = Firebase.database().ref('admin_users').child(localStorage.uid)
            .once('value')
            .then(resp => {
                this.setState({ user: resp.val() });
                var storeRef = Firebase.database().ref('stores')
                    .child(this.state.user.client_id).once('value')
                    .then(resp => {
                        if (resp.val()) {
                            this.setState({
                                stores: resp.val(),
                                titulos: Object.keys(resp.val()[0])
                            });
                            this.refs.container.success(
                                "Local añadido correctamente",
                                "Actualizado", {
                                    timeOut: 3000,
                                    extendedTimeOut: 10000
                                });
                        }
                    });
            });
    }

    callBack() {
        this.setState({ showModalAddFile: false });
        this.updateStores();
    }

    renderDataTable(titles) {
        if (titles[0]) {
            return (
                <DataTable
                    keys="id"
                    columns={titles}
                    initialData={this.state.stores}
                    initialPageLength={20}
                    initialSortBy={{ prop: titles[0].prop, order: 'descending' }}
                    pageLengthOptions={[20, 50, 100]}
                />
            )
        }
    }

    descarga(archivo) {
        document.location = archivo;
    }

    render() {
        var titles = [];
        if (this.state.titulos) {
            this.state.titulos.map((t) => {
                var tt = t;
                tt = tt.substring(tt.indexOf("_") + 1);
                titles.push({ title: tt, prop: t })
            })
        }
        var arrayStores = [];
        if (this.state.stores) {
            arrayStores = Object.values(this.state.stores);
        }
        return (
            <div className="animated fadeIn">
                <div className="row">
                    <div className="col-md-12">
                        <ToastContainer ref="container" style={{ top: "65px" }}
                            toastMessageFactory={ToastMessageFactory}
                            className="toast-top-right"
                        />
                        <div className="row">
                            <div className="col col-xs-6 text-right">
                                <button type="button" onClick={() => { this.setState({ showModalAddFile: true }) }} className="btn btn-outline-success">Subir Archivo</button>{"    "}
                                <button type="button" onClick={() => { this.descarga('/xlsx/locales_demo.xlsx') }} className="btn btn-outline-primary">Descargar Template</button>
                            </div>
                        </div>
                        <div>
                            {
                                this.renderDataTable(titles)
                            }
                        </div>
                        <Modal isOpen={this.state.showModal} toggle={() => { this.setState({ showModal: false }) }} className="modal-content">
                            <ModalHeader toggle={() => { this.setState({ showModal: false }) }}>Nuevo Local</ModalHeader>
                            <ModalBody>
                                <AddStore callBack={this.callBack} />
                            </ModalBody>
                        </Modal>
                        <Modal isOpen={this.state.showModalAddFile} toggle={() => { this.setState({ showModalAddFile: false }) }} className="modal-content">
                            <ModalHeader toggle={() => { this.setState({ showModalAddFile: false }) }}>
                                Subir Excel con locales
                            </ModalHeader>
                            <ModalBody>
                                <AddFromFile callBack={this.callBack} />
                            </ModalBody>
                        </Modal>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/stores/stores.js